<template>
  <div id="risk">    
    <vx-card title="Filter" code-toggler>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Month</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input-number v-model="params.week" min="1" max="12"/>
              </div>
            </div>
					</div>
					<div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-button class="mr-3 mb-2" @click="sendData()">Depositor Report</vs-button>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Clients</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input-number v-model="params.clients" min="1"/>
              </div>
            </div>
					</div>
				</div>	
        <div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Brokers</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-row mb-6">
                  <v-select class="w-full" multiple v-model="params.bk_name1" label="bk_name" :options="$store.state.brokers" :dir="$vs.rtl ? 'rtl' : 'ltr'" />                  
                </div>
                <div class="flex items-center">
                    <vs-checkbox v-model="selectAllCheckBox" icon-pack="feather" class="select-all-chexkbox ml-0">Select All</vs-checkbox>
                </div>
              </div>
            </div>
					</div>
				</div>      		
    </vx-card>	
    <vx-card>
        <vs-button @click="$router.push('/risk/persons').catch(() => {})" color="primary" type="border">Natural Persons</vs-button>
    </vx-card>
  </div>
</template>

<script>

import axios from "@/axios.js"
import VxCard from '../../../components/vx-card/VxCard.vue';
import vSelect from 'vue-select';
export default {
  components: { VxCard, vSelect },

  data() {
    
    let data = {
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["Broker name", "Client id", "Currency","Deposit amount", "Deposit count","Last deposit date","Username"],
      headerVal: ["broker_name", "client_id", "currency","deposit_amount", "deposit_count","last_deposit_date","username"],
      params:{clients:1,week:1,bk_name1:[],allSelected: false},
      endPoint:'risk',
      filters: {}
    }    
    data.columnDefs = JSON.parse(localStorage.getItem('riskColumns'))
    return data;
  },
  methods:{    
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    sendData: function(){
        let that = this;
        this.$vs.loading();
        this.params.allSelected = this.selectAllCheckBox;
        axios.post("/api/risk",this.params)
          .then((response) => {
            import('@/vendor/Export2Excel').then(excel => {
              const list = response.data;
              const data = this.formatJson(that.headerVal, list)
              excel.export_json_to_excel({
                header: that.headerTitle,
                data,
                filename: that.fileName,
                autoWidth: that.cellAutoWidth,
                bookType: that.selectedFormat
              })
              that.$vs.loading.close() 
            })
          })
          .catch(() => { })
    },
  },
  computed: {
    selectAllCheckBox:{
      get(){
        return this.params.bk_name1.length===this.$store.state.brokers.length;
      },
      set(){        
        if(this.params.bk_name1.length===this.$store.state.brokers.length){
          this.params.bk_name1.splice(0);
          return false;
        }
        this.params.bk_name1.splice(0);
        for(let i in this.$store.state.brokers){
          this.params.bk_name1.push(this.$store.state.brokers[i]);
        }
      }
    }
  },
  mounted() {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
  }
}

</script>